import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function Mechanism() {
  return <section className="w-full bg-navy-900 px-4 py-20" data-id="element-91">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-92">
        <div className="text-center mb-12" data-id="element-93">
          <div className="flex justify-center mb-6" data-id="element-94">
            <div className="w-20 h-20 rounded-full bg-gold/10 flex items-center justify-center border-2 border-gold" data-id="element-95">
              <ClockIcon className="w-10 h-10 text-gold" data-id="element-96" />
            </div>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-97">
            El Mecanismo Único
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-8" data-id="element-98"></div>
        </div>

        <div className="bg-navy-800/50 border border-gold/30 rounded-lg p-8 md:p-12" data-id="element-99">
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-100">
            El secreto está en el{' '}
            <span className="text-gold font-semibold" data-id="element-101">
              Reloj Biológico Zang-Fu
            </span>
            . En la Medicina China, cada hora de la noche está ligada a un
            órgano. Al aplicar presión en puntos específicos (como Shenmen o
            Anmian), actúas como un electricista que restablece los fusibles de
            tu cuerpo.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed mt-6" data-id="element-102">
            No es meditación; es{' '}
            <span className="text-gold font-semibold" data-id="element-103">
              ingeniería biológica aplicada
            </span>{' '}
            para forzar el estado de reposo.
          </p>
        </div>
      </motion.div>
    </section>;
}